import {gsap} from "gsap";
import App from "@templates/App/App.js";

const AboutProject = {

    init() {
        this.el = $('[url="o-projekte"]');
        if (!this.el.length) return;

        this.button = this.el.find("a#about-project");
        this.gallery = this.el.find("#gallery");

        this.bind();
    },

    bind() {
        this.button.click((evt) => {
            this.scrollToGallery();
            return false;
        })
    },

    scrollToGallery() {
        let offsetTop = this.gallery.offset().top;

        if (!App.isMobile) {
            offsetTop = offsetTop - 60;
        }

        gsap.to(window, {
            duration: .5,
            scrollTo: { y: offsetTop, autoKill: false }
        });
    }
}

export default AboutProject;